import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { TextButton } from '../TextButton';
import styles from './FilterPickerGroup.module.scss';
export const filterPickerGroupClearTestId = (parentTestId)=>parentTestId ? "".concat(parentTestId, "-clear") : 'clear';
export function FilterPickerGroup(props) {
    const { className, style, children, flexWrap, onClearClick, testId, clearLabel = 'Clear' } = props;
    // WHY: Clear is an action, not a state; a caller with nothing to clear passes no handler, so it is not rendered at all.
    const showClear = onClearClick != null;
    return /*#__PURE__*/ _jsxs("div", {
        style: style,
        className: cn(styles.root, {
            [styles.flexWrap]: flexWrap
        }, className),
        "data-testid": testId,
        children: [
            children,
            showClear ? /*#__PURE__*/ _jsx(TextButton, {
                onClick: onClearClick,
                skin: "primary",
                underline: "none",
                weight: "normal",
                variant: "paragraph2",
                testId: filterPickerGroupClearTestId(testId),
                // eslint-disable-next-line custom/no-hardcoded-bi-name-in-seagull -- FilterPickerGroup owns its inherent Clear action; pre-existing, not consumer-variable
                bi: {
                    name: 'clear_filters'
                },
                children: clearLabel
            }) : null
        ]
    });
}
